import { db } from '@/lib/firebase';
import type {
  Agent, Article, Asset, AssignmentRule, AuditEntry, Case, CatalogItem, Change, Company, CompanyActivity, ConfigurationItem, Contact, Contract, Counter, Group, Incident, Notification, Problem, SlaPolicy, UserProfile, WorkOrder, WorkOrderTask, AiUsageMonth, AgentAuditEntry, AgentRun, AgentUsage,
} from '@shared/types';
import { typedCollection, typedDoc } from './converters';

export const settingsDoc = <T extends { id: string }>(key: string) => typedDoc<T>(db, `settings/${key}`);
export const countersCol = () => typedCollection<Counter>(db, 'counters');
export const groupsCol = () => typedCollection<Group>(db, 'groups');
export const usersCol = () => typedCollection<UserProfile>(db, 'users');
export const userDoc = (uid: string) => typedDoc<UserProfile>(db, `users/${uid}`);

export const incidentsCol = () => typedCollection<Incident>(db, 'incidents');
export const incidentDoc = (id: string) => typedDoc<Incident>(db, `incidents/${id}`);
export const problemsCol = () => typedCollection<Problem>(db, 'problems');
export const problemDoc = (id: string) => typedDoc<Problem>(db, `problems/${id}`);
export const changesCol = () => typedCollection<Change>(db, 'changes');
export const changeDoc = (id: string) => typedDoc<Change>(db, `changes/${id}`);
export const cisCol = () => typedCollection<ConfigurationItem>(db, 'cis');
export const ciDoc = (id: string) => typedDoc<ConfigurationItem>(db, `cis/${id}`);
export const assetsCol = () => typedCollection<Asset>(db, 'assets');
export const assetDoc = (id: string) => typedDoc<Asset>(db, `assets/${id}`);
export const articlesCol = () => typedCollection<Article>(db, 'articles');
export const articleDoc = (id: string) => typedDoc<Article>(db, `articles/${id}`);
export const catalogItemsCol = () => typedCollection<CatalogItem>(db, 'catalogItems');
export const notificationsCol = () => typedCollection<Notification>(db, 'notifications');
export const agentsCol = () => typedCollection<Agent>(db, 'agents');
export const auditLogCol = () => typedCollection<AuditEntry>(db, 'auditLog');
export const slaPoliciesCol = () => typedCollection<SlaPolicy>(db, 'slaPolicies');
export const slaPolicyDoc = (id: string) => typedDoc<SlaPolicy>(db, `slaPolicies/${id}`);

// ---------- CRM ----------
export const companiesCol = () => typedCollection<Company>(db, 'companies');
export const companyDoc = (id: string) => typedDoc<Company>(db, `companies/${id}`);
export const companyActivityCol = (id: string) => typedCollection<CompanyActivity>(db, `companies/${id}/activity`);
export const contactsCol = () => typedCollection<Contact>(db, 'contacts');
export const contactDoc = (id: string) => typedDoc<Contact>(db, `contacts/${id}`);
export const contractsCol = () => typedCollection<Contract>(db, 'contracts');
export const contractDoc = (id: string) => typedDoc<Contract>(db, `contracts/${id}`);
export const assignmentRulesCol = () => typedCollection<AssignmentRule>(db, 'assignmentRules');
export const casesCol = () => typedCollection<Case>(db, 'cases');
export const caseDoc = (id: string) => typedDoc<Case>(db, `cases/${id}`);
export const workOrdersCol = () => typedCollection<WorkOrder>(db, 'workOrders');
export const workOrderDoc = (id: string) => typedDoc<WorkOrder>(db, `workOrders/${id}`);
export const workOrderTasksCol = (id: string) => typedCollection<WorkOrderTask>(db, `workOrders/${id}/tasks`);
export const aiUsageCol = () => typedCollection<AiUsageMonth>(db, 'aiUsage');
export const aiUsageDoc = (month: string) => typedDoc<AiUsageMonth>(db, `aiUsage/${month}`);
export const agentDoc = (id: string) => typedDoc<Agent>(db, `agents/${id}`);
export const agentAuditCol = (id: string) => typedCollection<AgentAuditEntry>(db, `agents/${id}/auditLog`);
export const agentUsageCol = (id: string) => typedCollection<AgentUsage>(db, `agents/${id}/usage`);
export const agentRunsCol = () => typedCollection<AgentRun>(db, 'agentRuns');
export const agentRunDoc = (id: string) => typedDoc<AgentRun>(db, `agentRuns/${id}`);
